/*    
<summary>
   This file is used to provide initial values or state to the User Data observables.
   Developer:Ashish Singh, Created Date: 29-August-2023
</summary>
*/



import { IAddOptionMenu } from "../../models/forms/IAddOptionMenu";


export const initialState:IAddOptionMenu = {
    RegistrationType: 0,
    BusinessTypeId: -1,
    Treatment: [],
    ReservationSite: "1",
    OptionName: "",
    TimeId: -1,
    TimeValue: 0,
    FeeExcludingTax: 0,
    TaxId: -1,
    TaxValue: 0,
    TaxAmount: 0,
    FeeIncludingTax: 0,
    Description: "",
    StartDate: "",
    EndDate: "",
    Status: "0",
    Remarks: "",
    IsAutoCalculateTax: true
}